import { render, staticRenderFns } from "./GetCustomerInvoiceByNumber.vue?vue&type=template&id=5ecb69c8&scoped=true&"
import script from "./GetCustomerInvoiceByNumber.vue?vue&type=script&lang=js&"
export * from "./GetCustomerInvoiceByNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ecb69c8",
  null
  
)

export default component.exports